import React from 'react'

export const Carcontext = React.createContext()